import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { QAndASides } from 'router/subrouters/DataRoom/models/QAndA';
import './RejectedQuestionBanner.styles.scss';
import './RejectedQuestionBanner.styles.responsive.scss';

type RejectedQuestionBannerProps = {
  className?: string;
  side: QAndASides;
  rejectQuestionRespond: string;
};

const RejectedQuestionBanner: React.FC<RejectedQuestionBannerProps> = (
  props,
) => {
  const { className, side, rejectQuestionRespond } = props;
  const { t } = useTranslation();

  const classes = classNames('rejected-question-banner', className);

  return (
    <div className={classes}>
      <p>{t('questionWasRejectedBySide', { side: t(`${side}Side`) })}</p>
      <p>{rejectQuestionRespond}</p>
    </div>
  );
};

export default RejectedQuestionBanner;
